var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Container, Grid, Message, Button } from 'semantic-ui-react';
import userApi from 'app/apis/user';
import { getUserFromStore } from '../../helpers/userHelper';
var MAX_RESEND_ALLOWED = 3;
var EmailVerificattion = /** @class */ (function (_super) {
    __extends(EmailVerificattion, _super);
    function EmailVerificattion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            timer: 60,
            noOfAttempts: 0,
            isLoading: false,
            statusText: '',
        };
        _this.sendVerificationEmail = _this.sendVerificationEmail.bind(_this);
        return _this;
    }
    EmailVerificattion.prototype.componentDidMount = function () {
        window.neo4jSandbox.tracking.event('SANDBOX_EMAIL_VERIFICATION_SHOW', {});
        this.startTimer();
    };
    EmailVerificattion.prototype.sendVerificationEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var noOfAttempts, user, _a, err, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        noOfAttempts = this.state.noOfAttempts;
                        if (noOfAttempts > MAX_RESEND_ALLOWED)
                            return [2 /*return*/];
                        this.setState({ isLoading: true, statusText: '' });
                        user = getUserFromStore();
                        return [4 /*yield*/, userApi.sendVerificationEmail(user.accessToken)];
                    case 1:
                        _a = _b.sent(), err = _a[0], result = _a[1];
                        this.setState({ isLoading: false });
                        if (!err) {
                            this.setState({
                                timer: 120,
                                statusText: 'Email sent',
                                noOfAttempts: noOfAttempts + 1,
                            });
                            window.neo4jSandbox.tracking.event('SANDBOX_EMAIL_VERIFICATION_RESEND', {});
                        }
                        else {
                            window.neo4jSandbox.tracking.event('SANDBOX_EMAIL_VERIFICATION_RESEND_FAILED', {});
                            this.setState({ statusText: 'Something went wrong' });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailVerificattion.prototype.startTimer = function () {
        var _this = this;
        setTimeout(function () {
            var timer = _this.state.timer;
            _this.setState({ timer: timer - 1 });
            _this.startTimer();
        }, 1000);
    };
    EmailVerificattion.prototype.render = function () {
        var _a = this.state, timer = _a.timer, isLoading = _a.isLoading, statusText = _a.statusText, noOfAttempts = _a.noOfAttempts;
        return (React.createElement(Container, null,
            React.createElement(Grid, { className: "mt4" },
                React.createElement(Grid.Column, null,
                    React.createElement(Message, { warning: true },
                        React.createElement("div", { className: "header" }, "Email Verification"),
                        React.createElement("p", null,
                            React.createElement("span", { className: "" }, "Please verify your email by clicking on the link we sent you."),
                            React.createElement("span", null, " Check your junk or spam folder as well.")),
                        noOfAttempts < MAX_RESEND_ALLOWED && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "button-group" },
                                React.createElement(Button, { loading: isLoading, onClick: this.sendVerificationEmail, disabled: timer > 0, color: "yellow", className: "mr2" }, "Resend Verification Email"),
                                React.createElement(Button, { onClick: function () { return window.location.reload(); } }, "Refresh")),
                            React.createElement("div", { className: "mt2" }, timer > 0 && React.createElement("span", null,
                                "in ",
                                timer,
                                " secs")))),
                        React.createElement("p", { className: "color-primary" }, statusText))))));
    };
    return EmailVerificattion;
}(React.Component));
export default EmailVerificattion;
